import { render, staticRenderFns } from "./SignModal.vue?vue&type=template&id=03b79084&scoped=true"
import script from "./SignModal.vue?vue&type=script&lang=js"
export * from "./SignModal.vue?vue&type=script&lang=js"
import style0 from "./SignModal.vue?vue&type=style&index=0&id=03b79084&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b79084",
  null
  
)

export default component.exports